import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`3.3 Harrods Hampers and Gift Baskets`}</h3>
    <p><strong parentName="p">{`3.3.1`}</strong>{` Sellers and Freelancers as defined in `}<strong parentName="p">{`1.6`}</strong>{` and `}<strong parentName="p">{`1.5a`}</strong>{` respectively can be recipients of seasonal `}<a parentName="p" {...{
        "href": "https://www.harrods.com/en-us/hampers"
      }}>{`Harrods Hampers`}</a>{` as defined in `}<strong parentName="p">{`1.29`}</strong>{` as luxury physical gift basket items for special occasions, shipped to over 200 countries worldwide: `}</p>
    <p>{`Examples of currently available hamper gifts depending on seasonal stock:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.harrods.com/en-us/p/harrods-the-festive-favourites-hamper-000000000007797534"
        }}>{`Harrods Festive Favorites Hamper`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.harrods.com/en-us/p/harrods-the-cheese-master-hamper-000000000007797536"
        }}>{`Harrods Luxury Cheese Hamper`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.harrods.com/en-us/p/harrods-the-family-sharing-hamper-000000000006934375"
        }}>{`Harrods Family Sharing Hamper`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.harrods.com/en-us/p/harrods-the-tea-time-treats-hamper-000000000006934390"
        }}>{`Harrods Tea Time Treats Hamper`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.harrods.com/en-us/p/harrods-the-luxury-halal-hamper-000000000007160397"
        }}>{`Harrods Luxury Halal Hamper`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.harrods.com/en-us/p/harrods-the-harrods-tuck-box-000000000007263886"
        }}>{`Harrods Tuck Box`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.harrods.com/en-us/p/harrods-the-gourmet-hamper-000000000006934384"
        }}>{`Harrods Gourmet Hamper`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.harrods.com/en-us/p/harrods-the-silent-night-hamper-000000000007622656"
        }}>{`Harrods Silent Night Hamper`}</a></li>
    </ul>
    <p>{`All Harrods Hampers available through HostJane are `}<strong parentName="p">{`non-alcoholic`}</strong>{`.`}</p>
    <p><strong parentName="p">{`3.3.2`}</strong>{` Limitations on Delivery of Harrods Hampers:`}</p>
    <p>{`Due to various logistical and operational constraints, HostJane is unable to facilitate the delivery of Harrods Hampers to every User in every jurisdiction. A curated selection of Harrods Hampers available as deliverable physical gifts is displayed on each User's respective studio or profile page.`}</p>
    <p><strong parentName="p">{`3.3.3`}</strong>{` Harrods Hamper Gifting Options:`}</p>
    <p>{`Users may choose to receive a physical Harrods Hamper delivered to the protected address specified in their account settings stored on encrypted U.S.-based servers. In such instances, HostJane facilitates the process by receiving the gift order and procuring the Harrods Hamper from Harrods for delivery to the User’s designated, data-encrypted address. Alternatively, at the User’s discretion, HostJane may provide a credit equivalent to the value of the Harrods Hamper. If the credit option is selected, the corresponding amount will be credited to the User’s "HostJane Balance" as defined in Section 1.24. Such funds may be withdrawn to a payment method of the User's choice after a forty-eight (48) hour clearance period, allowing the User to independently purchase the Harrods Hamper directly from Harrods. Withdrawals of the HostJane Balance may be initiated through the standard designated `}<a parentName="p" {...{
        "href": "https://www.69work.com/marketplace/settings/payouts"
      }}>{`withdrawal process`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      